export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBadgeStatus: function getBadgeStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/badge/get",
        method: "get",
        params: data
      });
    }
  };
});